export { default } from "ember-moment/services/moment";
